import { useState } from "react";
import { PLAYBOOKS } from "../../lib/manualKit";

export const Playbooks = () => {
  const [id, setId] = useState(PLAYBOOKS[0].id);
  const p = PLAYBOOKS.find((x) => x.id === id);
  return (
    <div data-testid="manual-playbooks">
      <div className="flex flex-wrap gap-2">
        {PLAYBOOKS.map((x) => (
          <button key={x.id} onClick={() => setId(x.id)} data-testid={`playbook-tab-${x.id}`}
            className={`px-4 py-2 border text-sm transition-colors ${id === x.id ? "border-brand text-brand bg-brand/[0.06]" : "border-white/15 text-white/60 hover:text-white"}`}>{x.name}</button>
        ))}
      </div>
      <div className="mt-6 grid lg:grid-cols-[1fr_1.2fr] gap-6" data-testid={`playbook-${p.id}`}>
        <div className="panel p-5">
          <p className="label-xs">Top dispute risks</p><p className="text-sm mt-1 text-white/80">{p.risk}</p>
          <p className="label-xs mt-5">Evidence that wins</p>
          <ul className="mt-2 space-y-2 text-sm text-white/75">{p.evidence.map((e) => <li key={e} className="flex gap-2"><span className="text-brand">▸</span>{e}</li>)}</ul>
        </div>
        <div className="panel p-5">
          <p className="label-xs">Defense strategy · step by step</p>
          <ol className="mt-3 space-y-3">{p.steps.map((s, i) => <li key={s} className="flex gap-3 text-sm text-white/80"><span className="font-mono text-brand">{String(i + 1).padStart(2, "0")}</span>{s}</li>)}</ol>
          <p className="mt-5 text-sm text-accent2 border-l-2 border-accent2 pl-3">{p.win}</p>
        </div>
      </div>
    </div>
  );
};
